import { AlertTriangle } from "lucide-react";
import { JOB_STATUS } from "@/lib/constants";

export const RefusalTag = ({ testId = "refusal-tag" }) => (
  <span data-testid={testId} className="refusal-tag" title="Astérisque (*) : ne souhaite pas recevoir de publicité (LPD / art. 3 LCD)">
    <AlertTriangle className="h-3 w-3" strokeWidth={2.5} />
    REFUS DE DÉMARCHAGE
  </span>
);

export const StatusBadge = ({ status, testId }) => {
  const meta = JOB_STATUS[status] || JOB_STATUS.pending;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${meta.cls}`}
    >
      {status === "running" && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#002FA7]" />}
      {meta.label}
    </span>
  );
};
